import React from "react";
import AccountPresenter from "./EmpAccountPresenter";
import { getObjectUseCase, upsertUseCase } from "../../usecases/object";
import BaseFormPage from "../../base/BaseFormPage";
import NavBar from "../../components/navbar";
import { InputInfo, InputInfoMerge } from "../../nq-component";
import fieldsPassword from "./fieldsPassword.json";
import { signInUseCase } from "../../usecases/user";
import click from "../../click";

class EmpAccountPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      progress: true,
      animationComplete: false,
    };
    this.presenter = new AccountPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      signInUseCase()
    );
    this.pictureRef = React.createRef();
  }

  componentDidMount() {
    this.presenter.componentDidMount();
    // Add animation delay for content appearance
    setTimeout(() => {
      this.setState({ animationComplete: true });
    }, 300);
  }

  getCollectionName() {
    return "users";
  }

  getObjectId() {
    const user = this.getCurrentUser();
    return user.id;
  }

  onClickProfile() {
    click(this.pictureRef.current);
  }

  onChangePassword(value, field) {
    this.presenter.onChangePassword(value, field);
  }

  onChangePicture(value) {
    this.presenter.onChangePicture(value);
  }

  onSubmitPassword(e) {
    e.preventDefault();
    this.presenter.onSubmitPassword();
  }

  navigateBack() {
    // override the default behavior
  }

  render() {
    // const user = this.state.object;
    const userEmp = this.getCurrentUser();
    const empId = userEmp.employee;
    const progress = this.state.progress;
    const schema = this.getSchema(this.getCollectionName());
    const { animationComplete } = this.state;

    if (!schema) return <h1>no schema</h1>;
    if (progress) return null;
    const fields = schema.fields;

    const user = this.getCurrentUser();

    console.warn("user", userEmp);
    return (
      <>
        <NavBar user={user} />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-5">
              <div className="row justify-content-start">
                <div className="col-lg-6 col-md-8">
                  <div
                    className={`bg-white p-4 shadow rounded-lg ${
                      animationComplete ? "opacity-100" : "opacity-0"
                    }`}
                    style={{
                      transition: "all 0.5s ease-in-out",
                      borderLeft: `0px solid #D18237`,
                      transform: animationComplete
                        ? "translateY(0)"
                        : "translateY(20px)",
                    }}
                  >
                    <div className="d-flex align-items-center mb-4">
                      <div
                        style={{
                          width: "8px",
                          height: "30px",
                          backgroundColor: "#D18237",
                          marginRight: "12px",
                          borderRadius: "2px",
                        }}
                      />
                      <h5 className="m-0 text-dark fw-bold">My Information</h5>
                    </div>

                    <ul className="list-group list-group-flush">
                      {[
                        {
                          icon: "bi bi-person",
                          label: "First Name",
                          value: user.employee.firstName,
                        },
                        {
                          icon: "bi bi-person-lines-fill",
                          label: "Middle Name",
                          value: user.employee.middleName,
                        },
                        {
                          icon: "bi bi-person-badge",
                          label: "Last Name",
                          value: user.employee.lastName,
                        },
                      ].map((item, index) => (
                        <div
                          key={index}
                          className="list-group-item border-0 px-0 py-3"
                          style={{
                            transition: `all 0.5s ease-in-out ${
                              0.1 + index * 0.15
                            }s`,
                            transform: animationComplete
                              ? "translateX(0)"
                              : "translateX(-20px)",
                            opacity: animationComplete ? 1 : 0,
                            borderBottom: "1px solid rgba(0,0,0,0.05)",
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <span
                              className={`${item.icon} fs-5`}
                              style={{ color: "#D18237" }}
                            ></span>
                            <div className="ms-3">
                              <small className="d-block text-muted">
                                {item.label}
                              </small>
                              <span className="fw-medium">
                                {item.value || "Not provided"}
                              </span>
                            </div>
                          </div>
                        </div>
                      ))}

                      {Object.keys(fields).map((field, index) => {
                        const { type, write, ...options } = fields[field];
                        if (write === false) return null;
                        if (field === "password") return null;
                        if (field === "username") return null;
                        if (field === "picture") return null;
                        if (field === "gender") return null;
                        if (field === "window") return null;
                        if (field === "id") return null;
                        if (field === "employeeId") return null;
                        if (type !== "String") return null;
                        const icon = options.icon || "bi bi-card-checklist";

                        return (
                          <div
                            className="mt-1 pt-3"
                            key={field}
                            style={{
                              transition: `all 0.5s ease-in-out 0.6s`,
                              transform: animationComplete
                                ? "translateX(0)"
                                : "translateX(-20px)",
                              opacity: animationComplete ? 1 : 0,
                            }}
                          >
                            <InputInfo
                              icon={icon}
                              field={field}
                              object={user}
                              onChange={this.onChange.bind(this)}
                              onSubmit={this.onSubmitForm.bind(this)}
                              label={options.label || field + ":"}
                              placeholder="fist-name last-name"
                              className="custom-input"
                            />
                          </div>
                        );
                      })}

                      <div
                        className="mt-1 pt-3"
                        style={{
                          transition: `all 0.5s ease-in-out 0.7s`,
                          transform: animationComplete
                            ? "translateX(0)"
                            : "translateX(-20px)",
                          opacity: animationComplete ? 1 : 0,
                        }}
                      >
                        <InputInfo
                          icon="bi bi-credit-card-2-front"
                          field="employeeId"
                          object={user}
                          label="Employee ID:"
                          edit={false}
                        />
                      </div>

                      <div
                        className="mt-1 pt-3"
                        style={{
                          transition: `all 0.5s ease-in-out 0.8s`,
                          transform: animationComplete
                            ? "translateY(0)"
                            : "translateY(20px)",
                          opacity: animationComplete ? 1 : 0,
                          borderTop: "1px solid rgba(0,0,0,0.05)",
                        }}
                      >
                        <InputInfoMerge
                          fields={fieldsPassword}
                          object={user}
                          onChange={this.onChangePassword.bind(this)}
                          onSubmit={this.onSubmitPassword.bind(this)}
                          label="Password:"
                        />
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <style jsx>{`
          .custom-input {
            transition: all 0.3s ease;
          }
          .custom-input:focus-within {
            box-shadow: 0 0 0 3px rgba(209, 130, 55, 0.2);
          }
          .list-group-item:hover {
            background-color: rgba(209, 130, 55, 0.05);
            transform: translateX(5px);
            transition: all 0.3s ease;
          }
        `}</style>
      </>
    );
  }
}

export default EmpAccountPage;
